export const dashToUnderscore = <T extends string>(str: T): T =>
  str.replaceAll('-', '_') as T
